import React from "react";
import { Link } from "react-router-dom";
import { BsTwitter, BsLinkedin, BsGithub } from "react-icons/bs";

const Footer = () => {
  return (
    <footer className="w-100 bg-slate-50">
      <div className="w-100  md:max-w-[960px] mx-auto px-4 py-12 md:py-20">
        <div className="flex  flex-col md:flex-row gap-5 md:justify-between md:items-center">
          <div>
            {" "}
            <Link to="/">
              <h1 className="text-xl md:text-2xl font-bold">
                Junior Dev <span className="text-amber-400">Blog</span>
              </h1>
              <p className="text-xs md:text-sm py-3 text-gray-500">
                Get your learning journey and job hunting right.
              </p>
            </Link>
          </div>
          <div>
            <p className="uppercase">Resources</p>
            <ul className="py-3">
              <li className="text-gray-500">
                <a href="#top">Blog</a>
              </li>
              <li></li>
            </ul>
          </div>
          <div>
            <p className="uppercase">Connect with me</p>
            <p className="flex gap-5 py-3">
              <a href="https://www.linkedin.com/in/saditz/" target="new">
                <span className="text-slate-600">
                  <BsLinkedin />
                </span>
              </a>
              <a href="https://twitter.com/abdulazizsaditz" target="new">
                <span className="text-slate-600">
                  <BsTwitter />
                </span>
              </a>
              <a href="https://github.com/kitindi" target="new">
                <span className="text-slate-600">
                  <BsGithub />
                </span>
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
